import { AddressModel, PurchaseBankAccountModel, PurchaseVatTableItemModel } from "@skylab-shared/dataModel";
import { EPurchaseSellerAddressParser } from "./e-purchase-seller-address-parser";

export function rewritePurchaseBankAccount(source: PurchaseBankAccountModel, target: PurchaseBankAccountModel): void {
    target.bankName = source.bankName;
    target.number = source.number;
    target.status = source.status;
    target.statusDate = source.statusDate;
    target.statusId = source.statusId;
}

export function rewritePurchaseVatTableItem(source: PurchaseVatTableItemModel, target: PurchaseVatTableItemModel): void {
    target.vatRateId = source.vatRateId;
    target.currencyGrossValue = source.currencyGrossValue;
    target.currencyNetValue = source.currencyNetValue;
    target.currencyVatValue = source.currencyVatValue;
    target.cost = source.cost;
    target.grossValue = source.grossValue;
    target.netValue = source.netValue;
    target.vatValue = source.vatValue;
    target.manual = source.manual;
}

export function rewriteAddressFromParsedEInvoiceAddress(target: AddressModel | null | undefined, source: AddressModel | null | undefined): void {
    if (!target || !source) return;

    const result = EPurchaseSellerAddressParser.parse(source);
    target.line1 = result.address;
    if (result.parsed) {
        target.city = result.parsed.city;
        target.zipCode = result.parsed.zipCode;
    }
}